import {
  UltimateGenerateRequestArticleTypeEnum,
  UltimateGenerateRequestPromptLanguageEnum,
} from '@models/Sessions/Idea/podcast-api';

export const articleTypes: Record<
  UltimateGenerateRequestArticleTypeEnum,
  Record<UltimateGenerateRequestPromptLanguageEnum, string>
> = {
  news_report: {
    en: 'news report',
    de: 'Meldungen',
  },
  collector: {
    en: 'collection',
    de: 'Sammler',
  },
  advice: {
    en: 'advice',
    de: 'Ratgeber',
  },
} as const;
